import { httpGetRequest } from "../clients/phronesisClient"
import { FeatureProperties } from "./authUtils"

export const ROLES_FEATURES_ENDPOINT = "/administration/roles/features"

export type featuresFlagsType = {
	[key in string]: Array<string>
}

export type featuresType = {
	module: string
	subModules: [string]
}

export interface FeatureResponse {
	feature: Array<featuresType>
}

export type authorizationResponse = {
	success: boolean
	features?: FeatureProperties
}

export const authorization = async (
	roles: Array<string>
): Promise<authorizationResponse> => {
	try {
		const authorizationResponse = await authorizationRequest(roles)
		return { success: true, features: authorizationResponse }
	} catch {
		return { success: false }
	}
}

const authorizationRequest = async (
	parameters: Array<string>
): Promise<featuresFlagsType> => {
	const response: FeatureResponse = await httpGetRequest(
		ROLES_FEATURES_ENDPOINT,
		undefined,
		undefined,
		undefined,
		{ roles: JSON.stringify(parameters) }
	)
	const featuresFlags: featuresFlagsType = {}
	response.feature.forEach(
		(feature) => (featuresFlags[feature.module] = feature.subModules)
	)
	return featuresFlags
}
